import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Button from '@atlaskit/button';
import Textfield from '@atlaskit/textfield';
import {DatePicker} from '@atlaskit/datetime-picker';
import styled from 'styled-components';
import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';
import {Link} from 'react-router-dom';
import FieldSelect from './FieldSelect';
import {withTranslation} from 'react-i18next';

const Container = styled.div`
  margin: 24px 16px 16px 16px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const FieldWrapper = styled.div`
  ${props => props.flex ? 'flex: 1;' : 'min-width: 240px;'}
  margin-left: 24px;
`;

const FiltersContainer = styled.div`
  display: flex;
  flex: 1;
`;

const ActionButtonContainer = styled.div`
  margin-left: 24px;
`;

class PageHeader extends PureComponent {
  static propTypes = {
    actionButton: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
    }),  
    customButton: PropTypes.shape({
      title: PropTypes.string,
      action: PropTypes.func,
      fetching: PropTypes.bool
    }),
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        keyName: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            id: PropTypes.any,
          })
        ),
        fetching: PropTypes.bool,
        getData: PropTypes.func,
        asyncMethodName: PropTypes.string,
      })
    ),
    filterByDatePlaceholder: PropTypes.string,
    filterByDate: PropTypes.bool,
    filterByDateKeyName: PropTypes.string,
    onFilter: PropTypes.func,
  };

  static defaultProps = {
    filterByDateKeyName: 'filterDate',
    filterByDate: false,
    onFilter: (fieldName, value) => console.log('PageHeader_onFilter', {[fieldName]:value}),
  }

  constructor(props){
    super(props);
    this.timeout =  0;
  }

  onSearchTextChange = e => {
    const searchText = e.target.value;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.props.onFilter('query', searchText);
    }, 1000);
  }

  onDatePickerChange = e => {
    const {filterByDateKeyName, onFilter} = this.props;
    onFilter(filterByDateKeyName, e);
  }

  render() {
    const {
      actionButton,
      customButton,
      filters,
      filterByDate,
      filterByDatePlaceholder,
      onFilter,
      t
    } = this.props;
    const flexFilterFields = (2 + (filters && filters.length ?  filters.length : 0)) > 3;
    
    return (
      <Container>
        <Wrapper>
          <FiltersContainer>
            <FieldWrapper flex={flexFilterFields} style={{margin: 0}}>
              <Textfield
                placeholder={t('Search')}
                aria-label="Filter"
                elemAfterInput={<EditorSearchIcon />}
                onChange={this.onSearchTextChange}
              />
            </FieldWrapper>
            {filterByDate && (
              <FieldWrapper flex={flexFilterFields}>
                <DatePicker
                  locale='ru'
                  placeholder={filterByDatePlaceholder ? filterByDatePlaceholder : t('By date')}
                  onChange={this.onDatePickerChange}
                />
              </FieldWrapper>
            )}
            {filters && filters.map(filter => (
              <FieldWrapper
                key={`Page_Header_Filter_${filter.keyName}`}
                flex={flexFilterFields}
              >
                {filter.type === 'date' ? (
                  <DatePicker
                    locale='ru'
                    placeholder={filter.placeholder ? filter.placeholder : t('By date')}
                    onChange={e => onFilter(filter.keyName, e)}
                  />
                ) : (
                  <FieldSelect
                    onChange={onFilter}
                    isMulti={true}
                    {...filter}
                  />
                )}
              </FieldWrapper>
            ))}
          </FiltersContainer>
          {actionButton && (
            <ActionButtonContainer>
              <Button
                appearance='danger'
                component={React.forwardRef((props, ref) => (
                  <Link {...props} ref={ref} to={actionButton.href}>
                    {props.children}
                  </Link>
                ))}
              >
                {actionButton.title}
              </Button>
            </ActionButtonContainer>
          )}
          {customButton && (
            <ActionButtonContainer>
              <Button
                appearance='danger'
                onClick={customButton.action}
                isLoading={customButton.fetching ?? true}
              >
               {customButton.title}
              </Button>
            </ActionButtonContainer>
          )}
        </Wrapper>
      </Container>
    );
  }
}

export default withTranslation('common')(PageHeader);
